/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  DposInterface,
  DposInterfaceInterface,
} from "../../dpos_contract_interface.sol/DposInterface";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "CommissionRewardsClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "commission",
        type: "uint16",
      },
    ],
    name: "CommissionSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Delegated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Redelegated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "RewardsClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UndelegateCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint64",
        name: "undelegation_id",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UndelegateCanceledV2",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UndelegateConfirmed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint64",
        name: "undelegation_id",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UndelegateConfirmedV2",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Undelegated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint64",
        name: "undelegation_id",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UndelegatedV2",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "ValidatorInfoSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "ValidatorRegistered",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "cancelUndelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "undelegation_id",
        type: "uint64",
      },
    ],
    name: "cancelUndelegateV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimAllRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "claimCommissionRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "confirmUndelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "undelegation_id",
        type: "uint64",
      },
    ],
    name: "confirmUndelegateV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "delegate",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "batch",
        type: "uint32",
      },
    ],
    name: "getDelegations",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "account",
            type: "address",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "stake",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "rewards",
                type: "uint256",
              },
            ],
            internalType: "struct DposInterface.DelegatorInfo",
            name: "delegation",
            type: "tuple",
          },
        ],
        internalType: "struct DposInterface.DelegationData[]",
        name: "delegations",
        type: "tuple[]",
      },
      {
        internalType: "bool",
        name: "end",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegator",
        type: "address",
      },
    ],
    name: "getTotalDelegation",
    outputs: [
      {
        internalType: "uint256",
        name: "total_delegation",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalEligibleVotesCount",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "undelegation_id",
        type: "uint64",
      },
    ],
    name: "getUndelegationV2",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "stake",
                type: "uint256",
              },
              {
                internalType: "uint64",
                name: "block",
                type: "uint64",
              },
              {
                internalType: "address",
                name: "validator",
                type: "address",
              },
              {
                internalType: "bool",
                name: "validator_exists",
                type: "bool",
              },
            ],
            internalType: "struct DposInterface.UndelegationData",
            name: "undelegation_data",
            type: "tuple",
          },
          {
            internalType: "uint64",
            name: "undelegation_id",
            type: "uint64",
          },
        ],
        internalType: "struct DposInterface.UndelegationV2Data",
        name: "undelegation_v2",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "batch",
        type: "uint32",
      },
    ],
    name: "getUndelegations",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "block",
            type: "uint64",
          },
          {
            internalType: "address",
            name: "validator",
            type: "address",
          },
          {
            internalType: "bool",
            name: "validator_exists",
            type: "bool",
          },
        ],
        internalType: "struct DposInterface.UndelegationData[]",
        name: "undelegations",
        type: "tuple[]",
      },
      {
        internalType: "bool",
        name: "end",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "batch",
        type: "uint32",
      },
    ],
    name: "getUndelegationsV2",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "stake",
                type: "uint256",
              },
              {
                internalType: "uint64",
                name: "block",
                type: "uint64",
              },
              {
                internalType: "address",
                name: "validator",
                type: "address",
              },
              {
                internalType: "bool",
                name: "validator_exists",
                type: "bool",
              },
            ],
            internalType: "struct DposInterface.UndelegationData",
            name: "undelegation_data",
            type: "tuple",
          },
          {
            internalType: "uint64",
            name: "undelegation_id",
            type: "uint64",
          },
        ],
        internalType: "struct DposInterface.UndelegationV2Data[]",
        name: "undelegations_v2",
        type: "tuple[]",
      },
      {
        internalType: "bool",
        name: "end",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "getValidator",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "total_stake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "commission_reward",
            type: "uint256",
          },
          {
            internalType: "uint16",
            name: "commission",
            type: "uint16",
          },
          {
            internalType: "uint64",
            name: "last_commission_change",
            type: "uint64",
          },
          {
            internalType: "uint16",
            name: "undelegations_count",
            type: "uint16",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "string",
            name: "description",
            type: "string",
          },
          {
            internalType: "string",
            name: "endpoint",
            type: "string",
          },
        ],
        internalType: "struct DposInterface.ValidatorBasicInfo",
        name: "validator_info",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "getValidatorEligibleVotesCount",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "batch",
        type: "uint32",
      },
    ],
    name: "getValidators",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "account",
            type: "address",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "total_stake",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "commission_reward",
                type: "uint256",
              },
              {
                internalType: "uint16",
                name: "commission",
                type: "uint16",
              },
              {
                internalType: "uint64",
                name: "last_commission_change",
                type: "uint64",
              },
              {
                internalType: "uint16",
                name: "undelegations_count",
                type: "uint16",
              },
              {
                internalType: "address",
                name: "owner",
                type: "address",
              },
              {
                internalType: "string",
                name: "description",
                type: "string",
              },
              {
                internalType: "string",
                name: "endpoint",
                type: "string",
              },
            ],
            internalType: "struct DposInterface.ValidatorBasicInfo",
            name: "info",
            type: "tuple",
          },
        ],
        internalType: "struct DposInterface.ValidatorData[]",
        name: "validators",
        type: "tuple[]",
      },
      {
        internalType: "bool",
        name: "end",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "batch",
        type: "uint32",
      },
    ],
    name: "getValidatorsFor",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "account",
            type: "address",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "total_stake",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "commission_reward",
                type: "uint256",
              },
              {
                internalType: "uint16",
                name: "commission",
                type: "uint16",
              },
              {
                internalType: "uint64",
                name: "last_commission_change",
                type: "uint64",
              },
              {
                internalType: "uint16",
                name: "undelegations_count",
                type: "uint16",
              },
              {
                internalType: "address",
                name: "owner",
                type: "address",
              },
              {
                internalType: "string",
                name: "description",
                type: "string",
              },
              {
                internalType: "string",
                name: "endpoint",
                type: "string",
              },
            ],
            internalType: "struct DposInterface.ValidatorBasicInfo",
            name: "info",
            type: "tuple",
          },
        ],
        internalType: "struct DposInterface.ValidatorData[]",
        name: "validators",
        type: "tuple[]",
      },
      {
        internalType: "bool",
        name: "end",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
    ],
    name: "isValidatorEligible",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "validator_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "reDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "proof",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "vrf_key",
        type: "bytes",
      },
      {
        internalType: "uint16",
        name: "commission",
        type: "uint16",
      },
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        internalType: "string",
        name: "endpoint",
        type: "string",
      },
    ],
    name: "registerValidator",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "commission",
        type: "uint16",
      },
    ],
    name: "setCommission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        internalType: "string",
        name: "endpoint",
        type: "string",
      },
    ],
    name: "setValidatorInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "undelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "validator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "undelegateV2",
    outputs: [
      {
        internalType: "uint64",
        name: "undelegation_id",
        type: "uint64",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class DposInterface__factory {
  static readonly abi = _abi;
  static createInterface(): DposInterfaceInterface {
    return new Interface(_abi) as DposInterfaceInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): DposInterface {
    return new Contract(address, _abi, runner) as unknown as DposInterface;
  }
}
